<mat-card class="summary-card">
  <div class="summary-title" style="background: #605da8;margin-bottom: 10px;">DT SHOP SALES BY DEPARTMENT</div>
  <canvas #dtShopTimeWiseSalesChart width="800" height="780" style="width:100%;max-width:100%"></canvas>
</mat-card>